// Root file for both client and server
import React, { PureComponent } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import 'normalize.css';
import 'antd/dist/antd.css';
import { ThemeProvider } from 'styled-components';

// import '../../assets/main.css';
import './globalStyles';
import theme from '../../theme';
import { fetchUserProfile, setUserCity } from '../HeaderContainer/actions';
import { DEFAULT_CITY } from '../HeaderContainer/constants';
import ErrorBoundry from '../../config/components/ErrorBoundry';

const Root = ({ route }) => {
  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundry>
        {renderRoutes(route.routes)}
      </ErrorBoundry>
    </ThemeProvider>
  );
};
Root.propTypes = {
  route: PropTypes.object.isRequired,
  // location: PropTypes.object,
};

const loadData = (store) => (
  Promise.all([
    store.dispatch(fetchUserProfile()),
    store.dispatch(setUserCity(DEFAULT_CITY)),
  ])
);

export default {
  component: Root,
  loadData,
};



// WEBPACK FOOTER //
// client/containers/Root/index.js